<template>
  <SplitterGroup
    :auto-save-id="LocalStorageKey.DRAFT_EDITOR_PANELS"
    :direction="isPlayground ? 'vertical' : 'horizontal'"
  >
    <SplitterPanel
      v-show="showLeftPane"
      id="left"
      :min-size="25"
      class="flex flex-col"
    >
      <slot name="panel-1"></slot>
    </SplitterPanel>

    <SplitterResizeHandle
      v-if="showLeftPane && props.showRight"
      class="group border-border transition dark:border-muted"
      :class="[isPlayground ? 'border-b' : 'border-l']"
    >
      <div
        v-if="!isPlayground"
        class="absolute top-[calc(50%-1rem)] z-20 -ml-2.5 cursor-grab rounded border border-border bg-card p-0.5 transition-colors hover:bg-muted group-focus:outline dark:bg-sidebar"
      >
        <Bars3Icon class="size-4 rotate-90 text-muted-foreground" />
      </div>
    </SplitterResizeHandle>

    <SplitterPanel
      v-if="props.showRight"
      id="right"
      :min-size="25"
      class="flex flex-col"
    >
      <slot name="panel-2"></slot>
    </SplitterPanel>
  </SplitterGroup>
</template>

<script lang="ts" setup>
import { SplitterGroup, SplitterPanel, SplitterResizeHandle } from "reka-ui";
import { computed } from "vue";

import Bars3Icon from "@/icons/heroicons/bars-3-outline.svg";
import { useMediaQuery } from "@/lib/composables/media-query";
import { LocalStorageKey } from "@/store/local_storage";

const props = defineProps<{
  showRight?: boolean;
}>();

const isMobile = useMediaQuery("(width < 768px)");
const isPlayground = computed(() => {
  return (
    new URLSearchParams(window.location.search).get("show_preview") === "true"
  );
});
const showLeftPane = computed(
  () => !props.showRight || !isMobile.value || isPlayground.value
);
</script>
